var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 115,
    viewBox: "0 0 280 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 115,
    rx: 8,
    fill: "#5855D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_283_2177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 280,
    height: 115
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 115,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_283_2177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.564 40.7958C324.652 59.8381 344.414 121.531 336.668 159.398C328.922 197.264 330.841 225.719 237.754 206.676C144.666 187.634 -9.08422 93.593 17.2713 -1.823C25.0175 -39.6899 138.477 21.7535 231.564 40.7958Z",
    fill: "url(#paint0_linear_283_2177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.849 76.8177C198.544 108.186 194.859 169.329 177.783 204.003C160.707 238.678 153.645 265.845 89.9488 234.477C26.2529 203.108 -60.2701 92.1465 -12.1466 5.75699C4.9295 -28.9174 71.1527 45.4495 134.849 76.8177Z",
    fill: "url(#paint1_linear_283_2177)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_2177",
    x1: 93.109,
    y1: 230.616,
    x2: 256.088,
    y2: -19.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_2177",
    x1: -25.003,
    y1: 236.323,
    x2: 204.67,
    y2: 69.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4CCD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveCard);
export default __webpack_public_path__ + "static/media/WaveCard.795e336370726c1e0cf2f9bdafbb2b1d.svg";
export { ForwardRef as ReactComponent };